












































import { computed, defineComponent, ssrRef, useAsync, useContext } from '@nuxtjs/composition-api'
import useComment from '@/composables/use-comment'
import useStore from '@/composables/use-store'
import ggoApi from '@/modules/ggo-api'
import useI18n from '@/composables/use-i18n'
import useDefaultMeta from '@/composables/use-default-meta'
import Store from '@/classes/Store'

export default defineComponent({
  layout: 'store',
  head: {},
  watchQuery: ['id'],
  async asyncData ({ error, params }) {
    if (!params.id) throw new Error('Missing `params.id`!')
    const { data, error: err } = await ggoApi.getStore({ id: Number(params.id) })

    if (!data || err) {
      error({ statusCode: 404 })
    }
  },
  setup () {
    const i18n = useI18n()

    const { params } = useContext()
    const { fetchStore } = useStore()

    const store = ssrRef<Store | null>(null)
    const fetchAsyncData = async () => {
      store.value = await fetchStore(+params.value.id)
    }
    useAsync(fetchAsyncData)

    const { setStoreId, loadMore, getStoreComments, comments, isAllLoaded } = useComment()

    const fetchAsyncComments = async () => {
      setStoreId(+params.value.id)
      await getStoreComments()
    }
    useAsync(fetchAsyncComments)

    const storeName = computed(() => store.value?.name)
    const storeRatingCount = computed(() => store.value?.rating?.count)
    useDefaultMeta({
      title: computed(() => String(i18n.t('SEO.comment.title', [storeName.value, storeRatingCount.value]))),
      description: computed(() => String(i18n.t('SEO.comment.metaDescription', [storeName.value]))),
    })

    return {
      store,

      comments,
      isAllLoaded,
      loadMore,
      storeName,
      storeRatingCount,
    }
  },
})
